import * as React from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import MovieContext from './context/store';

const Genre = ({getdata}) => {

    const context = React.useContext(MovieContext);
    

    const handleChange = (event) => {
        context.handleGenre(event.target.value);
        getdata();
    }

    return (
        <div>
            <h1>Which Genre are you in the mood&nbsp;for?</h1>
            <FormControl>
      <RadioGroup
        aria-labelledby="demo-radio-buttons-group-label"
        defaultValue="female"
        name="radio-buttons-group"
        onChange={(event) => handleChange(event)}
      >
        <FormControlLabel value="drama" control={<Radio />} label="Drama" />
        <FormControlLabel value="comedy" control={<Radio />} label="Comedy" />
        <FormControlLabel value="horror" control={<Radio />} label="Horror" />
        <FormControlLabel value="action" control={<Radio />} label="Action" />
        <FormControlLabel value="sci-fi" control={<Radio />} label="Sci-Fi" />
        <FormControlLabel value="fantasy" control={<Radio />} label="Fantasy" />
        <FormControlLabel value="romance" control={<Radio />} label="Romance" />
        <FormControlLabel value="crime" control={<Radio />} label="Crime-Thriller" />
        <FormControlLabel value="mystery" control={<Radio />} label="Mystery" />
        <FormControlLabel value="family" control={<Radio />} label="Family/Kids" />
      </RadioGroup>
    </FormControl>
        </div>
    )
}

export default Genre;